import Vue from "vue";
import VueRouter from "vue-router";

import Start from "../views/Start/Start.vue";

import Map from "../views/Home/Map.vue";

import Tour from "../views/Tours/Tour.vue";

import Pois from "../views/Pois/Pois.vue";

import Route from "../views/Routes/Route.vue";

import ModelDialog from "../components/Dialogs/ModelDialog.vue";

import Info from "../views/Info/Info.vue";
import TourList from "../views/Tours/TourList.vue";
import CityList from "../views/Cities/CityList.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    component: Start,
  },

  {
    path: "/home",
    component: Map,
  },

  {
    path: "/tour/:tour_id",
    component: Tour,
  },

  {
    path: "/pois",
    component: Pois,
  },

  {
    path: "/route",
    component: Route,
  },

  {
    path: "/model",
    component: ModelDialog,
  },

  {
    path: "/tour_list",
    component: TourList,
  },

  {
    path: "/city_list",
    component: CityList,
  },

  {
    path: "/info",
    component: Info,
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => {
    if (err.name != "NavigationDuplicated") {
      throw err;
    }
  });
};

export default router;
